// extracted by mini-css-extract-plugin
export default {"container":"StoreBanner_container__Buv44","bannerImage":"StoreBanner_bannerImage__YnORt"};